<template>
  <div>
    <!-- 角色管理标题 -->
    <ots-main-title></ots-main-title>
    <!--  -->
    <div class="titleTips">
      <span class="titleTips-left">
        {{ selectForm.roleType == 1 ? "院校管理员" : ( selectForm.roleType == 2 ?"教学点管理员" :'巡考教师') }}
      </span>
      <span class="titleTips-right">
        {{ selectForm.roleType == 1 ? "院校权限" :(selectForm.roleType == 2 ?"教学点权限":'巡考员权限')}}
      </span>
    </div>
    <!-- 角色管理搜索框 -->
    <ots-refer
      :selectList="selectList"
      :request-form="selectForm"
      @search="search"
    />
    <!-- table 表格 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :pagination="pagination"
      :batchOperBtn="batchOperBtn"
      @handleSelectionChange="bachOper"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
  </div>
</template>

<script>
/* 
  复杂逻辑结构功能开发
*/
import {
  queryRoleUserSetList,
  isSetUserRole,
} from "@/http/modules/user.js";
export default {
  name: "addUser",
  data() {
    return {
      // 判断用户状态 未添加/已添加
      isAdd: this.$route.query.isAdd,
      // 批量添加, 批量删除 按钮 
      batchOperBtn: [
        {
          title: this.$route.query.isAdd ? "批量移除" : "批量添加",
          icon: this.$route.query.isAdd? "iconfont icon-shanchu" : "iconfont icon-kaiqi",
          click: this.setTableList,
        },
      ],
      selectIds: [],
      selectList: [
        {
          title: "教学点",
          type: "select",
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "用户状态",
          type: "select",
          requestKey: "isSetRole",
          label: "name",
          value: "id",
          data: [
            {
              name: "未添加",
              id: "0",
            },
            {
              name: "已添加",
              id: "1",
            },
          ],
        },
        {
          title: "用户名",
          type: "input",
          requestKey: "userName",
          placeholder: "请输入",
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
      ],

      selectForm: {
        //教学点
        stationId: "",
        // 证件号
        cardNo: "",
        // 角色 ID
        roleId: this.$route.query.id,
        // 学校
        schoolId: "",
        // 用户状态
        isSetRole: this.$route.query.isAdd ? "1" : "0",
        // 用户名
        userName: "",
        // 姓名
        realName: "",
        // 权限类型
        roleType: this.$route.query.roleType,
        size: 10,
        page: 1,
      },

      tableHeader: [
        {
          title: "用户名",
          prop: "userName",
        
        },
        {
          title: "姓名",
          prop: "realName",
        
        },
        {
          title: "手机号",
          prop: "phone",
       
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: () => {
                if (this.isAdd) {
                  return "删除";
                } else {
                  return "添加";
                }
              },
              click: this.setTableList,
            },
          ],
        },
      ],

      tableOption: {
        multiple: true,
      },

      // 表格数据
      tableData: [],

      /* ***** 分页 ***** */
      pagination: {
        total: 0,
      },
    };
  },
  mounted() {
    this.getResult();
    this.getSelectList();
    if(this.$route.query.roleType == 2){
      this.tableHeader.unshift({
          title: "教学点",
          prop: "stationName",

      },)
    }else if(this.$route.query.roleType == 1){
     this.tableHeader.unshift({
          title: "院校",
          prop: "schoolName",

      },)
    }
  },

  methods: {
    /****************************
     * @this 获取**table**表格数据(判断用户状态)
     ***************************/
     search() {
      this.selectForm.page = 1;
      this.getResult();
    },
    getResult() {
      queryRoleUserSetList(this.selectForm).then((res) => {
        if(res.code == 1){
          this.tableData = res.data.records;
        this.pagination.total = res.data.total;
        }
      
        if (this.selectForm.isSetRole == "1") {
          this.batchOperBtn[0].title = "批量删除";
          this.isAdd = true;
        } else if (this.selectForm.isSetRole == "0") {
          this.batchOperBtn[0].title = "批量添加";
          this.isAdd = false;
        }
      });
    },

    /****************************
     * @this 表单配置项
     ***************************/
    getSelectList() {
      let isSchool = this.$route.query.roleType;
      if (isSchool == "1") {
        console.log(1)
        // 院校管理员
        this.selectList.splice(0, 1);
        this.mixin_getSelectSchool().then((data) => {
          let newSchoolList = [
            {
              id: "",
              name: "全部",
            },
            ...data,
          ];
          this.$set(this.selectList[0], "data", newSchoolList);
        });
      } else if(isSchool == "2") {
        // 教学点管理员
        console.log(2)
        this.selectList.splice(1, 1);
        this.mixin_getSelectStation().then((data) => {
          let newStationList = [
            {
              id: "",
              name: "全部",
            },
            ...data,
          ];
          this.$set(this.selectList[0], "data", newStationList);
        });
      }else{
        this.selectList=[
        {
          title: "用户状态",
          type: "select",
          requestKey: "isSetRole",
          label: "name",
          value: "id",
          data: [
            {
              name: "未添加",
              id: "0",
            },
            {
              name: "已添加",
              id: "1",
            },
          ],
        },
        {
          title: "用户名",
          type: "input",
          requestKey: "userName",
          placeholder: "请输入",
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
        ]
      }
    },

    /****************************
     * @this 删除用户,批量移除
     ***************************/
    // 1. 是否勾选复选框
    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.userId);
      });
      this.selectIds = idList;
    },
    // 2. 删除时判断是否选择用户
    beforeBatch() {
      if (this.selectIds.length > 0) {
        return true;
      } else {
        this.$message.warning("请先选择用户");
        return false;
      }
    },
    // 3. 配置参数 删除/添加 用户
    setTableList(row) {
      if (row || this.beforeBatch()) {
        // this.isAdd : true--删除 / false--添加
        let param = {
          userIds: row ? row.userId : this.selectIds.join(),
          roleId: this.$route.query.id,
          actionType: this.isAdd ? 0 : 1,
        };
        if(this.isAdd){
          // 移除用户角色
          this.$confirm('请确认是否要移除用户的角色？', '提示', {
            type: 'warning'
          }).then(() => {
            isSetUserRole(param).then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.getResult();
              }
            });
          }).catch(() => {
          })
        } else {
          // 添加用户角色
          isSetUserRole(param).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getResult();
            }
          });
        }
      } else {
        return false;
      }
    },

    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.selectForm.size = num;
      this.getResult();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getResult();
    },
  },
};
</script>

<style lang="less" scoped>
.titleTips {
  width: 100%;
  height: 64px;
  background: linear-gradient(90deg, #ebf0fa 0%, #ebf0fa 100%);
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: left;
  align-items: center;
  padding-left: 24px;
  box-sizing: border-box;
  .titleTips-left {
    display: inline-block;
    width: auto;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2d2f33;
    line-height: 28px;
    margin-right: 8px;
  }
  .titleTips-right {
    width: 90px;
    height: 22px;
    background: #d8ebff;
    border-radius: 2px;
    text-align: center;
    line-height: 22px;
    font-size: 13px;
    font-weight: 400;
    color: #006aff;
  }
}
</style>